
import React, { useState } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaSignInAlt, FaSpinner } from 'react-icons/fa';

const JWT_SECRET = '78bd01b1-6a7f-461e-b656-a0a4453729d9';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

const LoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPwd, setShowPwd] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const encryptPassword = (plain) => CryptoJS.AES.encrypt(plain, JWT_SECRET).toString();

    const handleLogin = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            const encryptedPassword = encryptPassword(password);

            const { data, status } = await axios.post(`${URL_BACKEND}/login`, { email, encryptedPassword });
            if (status === 200) {
                toast.success('Login bem-sucedido!');
                localStorage.setItem('userToken', data.token);
                localStorage.setItem('userName', data.nome);
                localStorage.setItem('userId', data.id);
                localStorage.setItem('userIdEmitente', data.id_emitente);
                localStorage.setItem('userCnpjEmitente', data.cnpj);
                navigate('/dashboard');
            }
        } catch (err) {
            const msg = err.response?.data || 'Erro ao fazer login.';
            toast.error(typeof msg === 'string' ? msg : 'Erro ao fazer login.');
        } finally {
            setLoading(false);
        }
    };

    const nomeProjeto = process.env.REACT_APP_NOME_PROJETO;

    return (
        <div style={ui.page}>
            <Toaster />
            <div style={ui.card}>
                <div style={ui.header}>
                    <h1 style={ui.brand}>{nomeProjeto}</h1>
                    <p style={ui.subtitle}>Acesse sua conta</p>
                </div>

                <form onSubmit={handleLogin} style={ui.form} autoComplete="on">
                    <div style={ui.group}>
                        <label htmlFor="email" style={ui.label}>E-mail</label>
                        <div style={ui.inputWrap}>
                            <span style={ui.leadingIcon}><FaEnvelope /></span>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={ui.input}
                                placeholder="seuemail@exemplo.com"
                                required
                            />
                        </div>
                    </div>

                    <div style={ui.group}>
                        <label htmlFor="password" style={ui.label}>Senha</label>
                        <div style={ui.inputWrap}>
                            <span style={ui.leadingIcon}><FaLock /></span>
                            <input
                                id="password"
                                type={showPwd ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={ui.input}
                                placeholder="Sua senha"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPwd((s) => !s)}
                                style={ui.trailingBtn}
                                aria-label={showPwd ? 'Ocultar senha' : 'Mostrar senha'}
                            >
                                {showPwd ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" disabled={loading} style={{ ...ui.primaryBtn, ...(loading ? ui.btnDisabled : {}) }}>
                        {loading ? (
                            <>
                                <FaSpinner className="fa-spin" style={{ marginRight: 8 }} /> Entrando…
                            </>
                        ) : (
                            <>
                                <FaSignInAlt style={{ marginRight: 8 }} /> Entrar
                            </>
                        )}
                    </button>
                </form>

                <div style={ui.footerHint}>
                    Esqueceu a senha?{' '}
                    <a href="#" onClick={(e) => e.preventDefault()} style={ui.link}>
                        Fale com o suporte
                    </a>
                </div>
            </div>
        </div>
    );
};

/** 🎨 Ajustes finos de UI */
const ui = {
    page: {
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background:
            'radial-gradient(800px 500px at 10% 10%, rgba(102,126,234,.08), transparent 40%), radial-gradient(800px 500px at 90% 90%, rgba(118,75,162,.08), transparent 40%), #f8fafc',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
        color: '#111827'
    },

    card: {
        width: '100%',
        maxWidth: 440,
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        backgroundColor: '#fff',
        boxShadow: '0 18px 36px rgba(0,0,0,.08)',
    },

    header: {
        padding: 24,
        background: 'linear-gradient(135deg, #6b74f1 0%, #7a4fb0 100%)',
        color: '#fff',
        borderRadius: '16px 16px 0 0', // <- resolve o canto "quadrado"
    },
    brand: { margin: 0, fontSize: '1.45rem', fontWeight: 800 },
    subtitle: { margin: '6px 0 0 0', opacity: .95 },

    form: { padding: 20, display: 'grid', gap: 16 },
    group: { display: 'grid', gap: 8 },
    label: { fontSize: '.875rem', color: '#374151', fontWeight: 700 },

    inputWrap: { position: 'relative' },
    leadingIcon: {
        position: 'absolute',
        left: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: 14,
        color: '#6b7280',
        pointerEvents: 'none',
    },
    input: {
        width: '80%',
        height: 44,
        padding: '0 44px 0 36px', // espaço correto pros ícones
        borderRadius: 10,
        border: '2px solid #e5e7eb', // 2px pra dar firmeza
        backgroundColor: '#fff',
        fontSize: '0.95rem',
        outline: 'none',
        transition: 'border-color .15s ease, box-shadow .15s ease',
        boxShadow: '0 0 0 0 rgba(102,126,234,0)',
    },
    trailingBtn: {
        position: 'absolute',
        right: 6,
        top: '50%',
        transform: 'translateY(-50%)',
        height: 32,
        width: 36,
        display: 'grid',
        placeItems: 'center',
        border: 'none',
        background: 'transparent',
        color: '#6b7280',
        cursor: 'pointer',
        borderRadius: 8,
    },

    primaryBtn: {
        width: '100%',
        height: 48,
        marginTop: 4,
        borderRadius: 12,
        background: 'linear-gradient(135deg, #667eea 0%, #7c8cf5 100%)',
        border: '2px solid #667eea',
        color: '#fff',
        fontWeight: 800,
        fontSize: '.96rem',
        letterSpacing: .2,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 18px rgba(102,126,234,.28)',
        transition: 'transform .12s ease, box-shadow .12s ease, filter .12s ease',
    },
    btnDisabled: { opacity: .85, cursor: 'not-allowed', filter: 'grayscale(10%)' },

    footerHint: {
        padding: '8px 20px 20px',
        textAlign: 'center',
        fontSize: '.875rem',
        color: '#6b7280'
    },
    link: { color: '#667eea', textDecoration: 'none', fontWeight: 800 }
};

// Pequeno “focus style” global para inputs (sem CSS-in-JS real)
const _applyFocusRing = (() => {
    // adiciona um handler simples para foco se quiser refinar ainda mais no app real
    return true;
})();

export default LoginScreen;
